import { render, staticRenderFns } from "./CaseDetailV2.vue?vue&type=template&id=69346fe2&scoped=true"
import script from "./CaseDetailV2.vue?vue&type=script&lang=js"
export * from "./CaseDetailV2.vue?vue&type=script&lang=js"
import style0 from "./CaseDetailV2.vue?vue&type=style&index=0&id=69346fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69346fe2",
  null
  
)

export default component.exports